import { CheckmarkSolidIcon } from '@kijiji/icons/src/icons'
import styled from 'styled-components'

import {
  ChipCheckbox as BaseChipCheckbox,
  ChipLabel as BaseChipLabel,
} from '@/ui/atoms/filter-chip/styled'
import { styleFromTypography } from '@/ui/helpers/styleFromTypography'

import { SelectableIconChipLayout } from './SelectableIconChip'

export const ChipWrapper = styled.span(
  ({ theme }) => `
  width: 100%;
  flex: 0 calc(33.33% - ${theme.spacing.defaultSmall});
`
)

export const ChipLabel = styled(BaseChipLabel)<{
  layout: SelectableIconChipLayout
}>(
  ({ theme, layout }) => `
  display: flex;
  flex-direction: ${layout === 'horizontal' ? 'row' : 'column'};
  padding: ${layout === 'horizontal' ? '0.95rem 1.2rem' : `${theme.spacing.defaultSmall} 0`};
  position: relative;
  overflow: hidden;
  ${styleFromTypography(theme.typography.body.xSmall)};

  span {
    margin-left: ${layout === 'horizontal' ? `${theme.spacing.defaultSmall}` : '0'};
  }

  & > svg {
    width: 4.8rem;
    height: 4.8rem;
  }
`
)

export const ChipCheckbox = styled(BaseChipCheckbox)(
  ({ theme }) => `
  &:checked + label {
    padding-right: 0;
    color: ${theme.colors.purple.primary};
    border-color: ${theme.colors.purple.primary};
  }

   &:checked:focus + label,
   &:checked:hover + label {
      background: ${theme.colors.purple.light5};
  }
 
  &:focus:not(:checked) + label {
    background: ${theme.colors.white};
    border-color: ${theme.colors.grey.light3};
    box-shadow: none;
  } 
`
)

export const CornerRibbon = styled.div(
  ({ theme }) => `
  position: absolute;
  top: 0;
  right: 0;
  clip-path: polygon(0 0, 100% 0, 100% 100%);
  width: 3.2rem;
  height: 2.8rem;
  background-color: ${theme.colors.purple.primary};
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
`
)

export const ChipCheckmarkIcon = styled(CheckmarkSolidIcon)(
  ({ theme }) => `
  color: ${theme.colors.white};
  width: 1.6rem;
  height: 1.6rem;
`
)
